import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { authTokenSelector } from 'redux/auth/selectors';
import { fetchEvents, appendEvent } from 'redux/events/actions';
import { getEvents } from 'redux/events/selectors';
import { keycloakSelector } from 'redux/keycloak/selectors';
import Studies from './Studies';

const mapStateToProps = (state: any) => ({
  events: getEvents(state),
  authToken: authTokenSelector(state),
  keycloak: keycloakSelector(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchEvents: (token: string) => dispatch(fetchEvents(token)),
  appendEvent: (event: any) => dispatch(appendEvent(event)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Studies)
